import constants from '@constants'
import { FetcherError } from './errors'
import type { Fetcher } from './types'

function getError(errors: any[] | null, status: number) {
  errors = errors ?? [{ message: 'Failed to fetch Shopify API' }]
  return new FetcherError({ errors, status })
}

async function getAsyncError(res: Response) {
  const data = await res.json()
  return getError(data.errors, res.status)
}

async function handleFetchResponse(res: Response) {
  if (res.ok) {
    const { data, errors } = await res.json()

    if (errors && errors.length) {
      throw getError(errors, res.status)
    }

    return data
  }

  throw await getAsyncError(res)
}

const fetcher: Fetcher = async fetchOptions => {
  const API_URL = `https://${constants.SHOPIFY_STORE_DOMAIN}/api/2023-01/graphql.json`
  const API_TOKEN = constants.SHOPIFY_STOREFRONT_ACCESS_TOKEN
  const { COUNTRY_CODE, LANGUAGE_CODE } = constants

  const { variables, query, url = API_URL, method = 'POST' } = fetchOptions
  const { locale, ...rest } = variables ?? {}
  const vars = {
    country: COUNTRY_CODE,
    language: LANGUAGE_CODE,
    ...rest,
  }

  const options = {
    method,
    body: JSON.stringify({ query, variables: vars }),
    headers: {
      'X-Shopify-Storefront-Access-Token': API_TOKEN!,
      'Content-Type': 'application/json',
      ...(locale && { 'Accept-Language': locale }),
    },
  }

  return handleFetchResponse(await fetch(url, options))
}

export default fetcher
